import { Client } from "apex-logs";
export const logger = new Client({
    url: "https://logs-gn33clh3la-dt.a.run.app",
    authToken: "1fiSkoBZVRAQVoJlIfGmFK1OyGk",
});
const PROJECT_ID = "oopy_free_templates";
export const addEvents = (events) => logger.addEvents({
    project_id: PROJECT_ID,
    events,
});
